import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map } from 'rxjs';
import { LanguageService } from '../services/language.service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private languageService: LanguageService) { }

  transform(key: string, params?: { [key: string]: any }): Observable<string> {
    return this.languageService.getTranslation(key).pipe(
      map(translation => {
        if (params) {
          Object.keys(params).forEach(param => {
            translation = translation.replace(`{{${param}}}`, params[param]);
          });
        }
        return translation;
      })
    );
  }
}
